export interface HttpOptions {
  url: string;
  data?: any;
  headers?: Record<string, string>;
}

// Añade por defecto Content-Type: application/json y permite extender con otros headers
export function withJsonHeaders(options: HttpOptions): HttpOptions {
  return {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('auth_token') || ''}`,
      ...(options.headers || {})
    }
  };
}
